import { ROUTE_STROKE_WIDTH } from "../CircuitPathsLayer/constants";

export const POLYGON_FILL_OPACITY = 0.12;
export const SELECTED_POLYGON_FILL_OPACITY = 0.2;
export const POLYGON_STROKE_WIDTH = ROUTE_STROKE_WIDTH;
export const SELECTED_POLYGON_STROKE_WIDTH = ROUTE_STROKE_WIDTH * 1.25;
// A thin white band under the selected outline separates it from the plan's own lines
export const SELECTED_POLYGON_HALO_WIDTH = SELECTED_POLYGON_STROKE_WIDTH + 4;
export const SELECTED_POLYGON_HALO_COLOR = "#FFFFFF";
// A room spans a large part of the page, so its badge is sized well above an element marker
export const LABEL_FONT_SIZE_FACTOR = 1.5;
export const LABEL_PADDING_X_FACTOR = 0.6;
export const LABEL_PADDING_Y_FACTOR = 0.3;
export const LABEL_CORNER_RADIUS_FACTOR = 0.35;
export const LABEL_FONT_FAMILY = "Arial";
export const LABEL_FONT_WEIGHT = "bold";
export const LABEL_TEXT_COLOR = "#FFFFFF";
export const LABEL_OUTLINE_COLOR = "#FFFFFF";
export const LABEL_OUTLINE_WIDTH = 2;
// A long room name would span the whole plan, so the badge shows its start only
export const LABEL_MAX_CHARACTERS = 35;
export const LABEL_ELLIPSIS = "…";
